import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter
} from "@angular/core";

import domtoimage from "dom-to-image";

@Component({
  selector: "app-selfie",
  templateUrl: "./selfie.component.html",
  styleUrls: ["./selfie.component.scss"]
})
export class SelfieComponent implements OnInit, OnChanges {
  @Input() imageSrc: string;
  @Output() resetInput = new EventEmitter<boolean>();
  imageCreated=false;
  image: boolean;

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    //console.log("Change Detected: ", this.imageSrc);

    if (this.imageSrc) {
      this.image = true;
    }
  }

  closePopup() {
    this.resetInput.emit(true);
    this.image = false;
    this.imageSrc = "";
  }

  share() {
    var node = document.getElementById("modalImage");
    //var node = ' <div class="modalImage">< img  width="300px" class="logoSelfie" src = "../../assets/images/Ooredoo1.svg" alt = "" ><img src="'+this.imageSrc+'" ><br><br><p>text</p></div>';
    domtoimage.toPng(node).then(function(dataUrl) {
      
      var canvas = <HTMLCanvasElement>document.getElementById("c");
      var ctx = canvas.getContext("2d");
     
      var newImage = new Image();

      newImage.src = dataUrl;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = "#c4c4c4";
      ctx.lineWidth = 10;
      ctx.strokeRect(0, 0, canvas.width, canvas.height);
      ctx.textAlign = "center";
      ctx.font = "16px 'Komika Axis', Arial, sans-serif";
      ctx.fillStyle = "#52606c";
     
      newImage.onload = function() {
        
        var wrh = newImage.width / newImage.height;
        var newWidth = newImage.width;
        var topMargin = 25;
        var newHeight = newImage.height;
        canvas.width= newImage.width
        canvas.height= newImage.height
        ctx.drawImage(
          newImage,
          canvas.width / 2 - newWidth / 2,
          topMargin,
          newWidth,
          newHeight
        );        
      }
    });
    
  }
  fbs_click(u) {
    console.log(u);

    window.open(
      "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(u),
      "sharer",
      "toolbar=0,status=0,width=626,height=436"
    );
    return false;
  }
}
